import Config from "../Config";
import { isBasicAuth, isOauth } from "../_components/oauth/OAuth";
import RequestHelper from "./RequestHelper";

export default class Commons
{
    static removeCurlyBracketsFromId = (sId) =>
    {
        if (sId.startsWith("{") && sId.endsWith("}"))
        {
            sId = sId.substring(1, sId.length - 1);
        }
        return sId;
    }

    static encodeUrlReqBody = (aBodyRaw) =>
    {
        let aBodyForm = [];
        for (let sKey in aBodyRaw)
        {
            let aEncodedKey = encodeURIComponent(sKey);
            let aEncodedVal = encodeURIComponent(aBodyRaw[sKey]);
            aBodyForm.push(aEncodedKey + "=" + aEncodedVal);
        }
        aBodyForm = aBodyForm.join("&");
        return aBodyForm;
    }

    static getAnpRepo = async () =>
    {
        await RequestHelper.sendRequestSimple(
        {
            request: Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.getRepo,
                dataType: "json"
            }),
            dataType: "json",
        }).then((aResponse) =>
        {
            if (aResponse && aResponse.isErr)
            {
                console.error(aResponse.message);
                throw new Error(aResponse.message)
            }
            let aRepos = [];
            if (aResponse.hasOwnProperty("repos") && aResponse.repos.length > 0)
            {
                for (let i = 0; i < aResponse.repos.length; i++)
                {
                    aRepos.push(
                    {
                        name: aResponse.repos[i].name,
                        id: aResponse.repos[i].id
                    })
                }
            }
            if (!Array.isArray(aRepos) || 0 >= aRepos.length || !aRepos[0].id)
            {
                console.error("No repository found!");
                throw new Error()
            }
            Config.setReposAvailable(aRepos);
        });
    }

    static checkTemplatesObjGroup = async () =>
    {
        let aTemplatesGroup = {};

        const productVersion = Config.getProductName();
        let includeRWF = "";
        if(productVersion === "ADONIS"){
            includeRWF = "&attribute=MFB_RWF_VERSION"
        }

        await RequestHelper.sendRequestSimple(
        {
            request: Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.getObjectGroup.replace(/%repo_id%/g, Config.aAnpRepo.id).replace(/%group_id%/g, "root").concat(includeRWF),
                dataType: "json"
            }),
            dataType: "json",
        }).then((aResponse) =>
        {
            let aMainGroup = null;
            if (aResponse && aResponse.isErr)
            {
                console.error(aResponse.message);
                throw new Error(aResponse.message)
            }
            let aObjGroup = {};
            if (aResponse.hasOwnProperty("group") && aResponse.group.hasOwnProperty("subgroups") && 0 < aResponse.group.subgroups.length)
            {
                const aObjectsGroup = aResponse.group.subgroups.find(function(aSubgroup)
                {
                    return Config.strings.repo.objects === aSubgroup.name || (Array.isArray(Config.strings.repo.objects) && Config.strings.repo.objects.includes(aSubgroup.name));
                });
                if (aObjectsGroup && aObjectsGroup.hasOwnProperty("id"))
                {
                    aMainGroup = {
                        id: Commons.removeCurlyBracketsFromId(aObjectsGroup.id),
                        name: aObjectsGroup.name
                    };
                }
                if (aObjectsGroup.hasOwnProperty("subgroups") && 0 < aObjectsGroup.subgroups.length)
                {
                    let aObjGroupData = aObjectsGroup.subgroups.find(function(aSubgroup)
                    {
                        return Config.sAnpTemplateObjGroup === aSubgroup.name;
                    });
                    if (aObjGroupData)
                    {
                        aObjGroup.id = aObjGroupData.id;
                        aObjGroup.name = aObjGroupData.name;
                    }
                }
            }
            if (aObjGroup.hasOwnProperty("id"))
            {
                aObjGroup.id = Commons.removeCurlyBracketsFromId(aObjGroup.id);
                aTemplatesGroup = aObjGroup;
            }
            if (aMainGroup)
            {
                aTemplatesGroup["maingroup"] = aMainGroup
            }
        });

        return aTemplatesGroup;
    }

    static createUrlParamsList = (aParams) =>
    {
        let sList = [];
        for (let sKey in aParams)
        {
            sList.push(sKey + "=" + aParams[sKey]);
        }
        if (0 < sList.length)
        {
            return sList.join("&");
        }
        return null;
    }

    static createGatewayRequestUrl = (aParams) =>
    {
        if (!aParams.hasOwnProperty("url") || !aParams.url)
        {
            return null;
        }
        let sReqUrl = Config.requestDirect;
        if (aParams.hasOwnProperty("endpoint"))
        {
            sReqUrl = aParams.endpoint;
        }

        let aUrlParams;
        if (aParams.isCustomUrl)
        {
            aUrlParams = {
                url: encodeURIComponent(aParams.url)
            };
        }
        else
        {
            aUrlParams = {
                url: encodeURIComponent(Config.baseURL.concat(aParams.url))
            };
        }
        if (aParams.hasOwnProperty("dataType") && aParams.dataType)
        {
            aUrlParams["dataType"] = aParams.dataType;
        }
        // if (localStorage["gateway_token"] && !aParams.preventToken)
        // {
        //     let aGatewayToken = JSON.parse(localStorage["gateway_token"]);
        //     aUrlParams["token"] = aGatewayToken.token;
        // }
        if (aParams.extraUrlParams)
        {
            for (let sKey in aParams.extraUrlParams)
            {
                aUrlParams[sKey] = aParams.extraUrlParams[sKey]
            }
        }

        const sUrlParamsString = Commons.createUrlParamsList(aUrlParams);
        if (sUrlParamsString && sReqUrl)
        {
            sReqUrl = sReqUrl.concat("?", sUrlParamsString);
        }

        if (isOauth())
        {
            return Config.baseURL.concat(aParams.url)
        }
        
        return sReqUrl;
    }

    static getAuthHeaderToken = () =>
    {
        if (isBasicAuth())
        {
            if (localStorage["gateway_token"])
            {
                let aGatewayToken = JSON.parse(localStorage["gateway_token"]);
                if (aGatewayToken.hasOwnProperty("token") && aGatewayToken.token)
                {
                    return ("Token " + aGatewayToken.token);
                }
            }
        }

        if (isOauth())
        {
            if (localStorage["SSO-Credentials"])
            {
                let aGatewayToken = JSON.parse(localStorage["SSO-Credentials"]);
                if (aGatewayToken.hasOwnProperty("access_token") && aGatewayToken.access_token)
                {
                    return ("Bearer " + aGatewayToken.access_token);
                }
            }
        }

        return null;
    }

    static getAdoVersion = async () =>
    {
        await RequestHelper.sendRequestSimple(
        {
            request: Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.testAuth,
                dataType: "json"
            }),
            dataType: "json",
        }).then((aResponse) =>
        {
            if (aResponse && aResponse.isErr)
            {
                console.error(aResponse.message);
                return;
            }
            let aVersionInfo = aResponse;
            if (
                aResponse &&
                aResponse.hasOwnProperty("productVersion") && typeof aResponse.productVersion === "string" &&
                aResponse.hasOwnProperty("productName") && typeof aResponse.productName === "string"
            )
            {
                const aVersion = aResponse.productVersion.split(".");
                if ((aResponse.productName.includes("ADONIS") && parseInt(aVersion[0]) >= 13) || (aResponse.productName.includes("ADOIT") && parseInt(aVersion[0]) >= 14))
                {
                    aVersionInfo["rest_version"] = "2.1";
                }
                else
                {
                    aVersionInfo["rest_version"] = "2.0";
                }
            }
            localStorage["ado_version"] = JSON.stringify(aVersionInfo);
        });
    }

    static isAdoit = () =>
    {
        const aAdoVersion = JSON.parse(localStorage["ado_version"]);
        if (aAdoVersion && aAdoVersion.hasOwnProperty("productName") && aAdoVersion.productName.toLowerCase().includes("adoit"))
        {
            return true;
        }
        if (aAdoVersion && aAdoVersion.hasOwnProperty("productName") && aAdoVersion.productName.toLowerCase().includes("adonis"))
        {
            return false;
        }
        return undefined;
    }
}